// src/store/governmentResources.js

import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API } from '../../constants';
import { application } from '../../services/application';
import { onPending, onPendingDone } from '../helpers/sharedCases';

export const getGovernmentResources = createAsyncThunk('governmentResources/getList', async () => {
  const resp = await application.call(API.GOVERNMENT_RESOURCES.GET_LIST);
  const data = Array.isArray(resp) ? resp : resp.result;
  return data || [];
});

export const actions = { getGovernmentResources };

const INITIAL_STATE = {
  items: [],
  pending: false,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(getGovernmentResources.pending, onPending)
    .addCase(getGovernmentResources.fulfilled, (state, { payload }) => {
      state.items = payload;
      state.pending = false;
    })
    .addCase(getGovernmentResources.rejected, onPendingDone);
});
